export default __webpack_public_path__ + "assets/facebook-icon-34701f1e1fd3b7c421f06a45ab00fb11.svg";